import type { GUIDScreenProps } from "./types";

function Techy({ line1, line2 }: GUIDScreenProps) {
  return (
    <svg viewBox="0 0 800 340" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3024_5373)">
        <rect
          width="800"
          height="340"
          rx="54"
          fill="#1F2022"
          style={{ fill: "#1F2022", fillOpacity: 1 }}
        />
        <g filter="url(#filter0_f_3024_5373)">
          <g opacity="0.5">
            <path
              d="M15.0146 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M57.6963 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M100.378 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M143.06 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M185.741 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M228.423 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M271.104 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M313.786 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M356.468 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M399.149 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M441.831 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M655.239 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M484.513 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M697.921 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M527.194 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M740.603 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M569.876 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M783.284 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M612.558 -11.6416V337.673"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
          </g>
          <g opacity="0.5">
            <path
              d="M868.333 20.1123L-54.3332 20.1123"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 62.7939L-54.3332 62.7939"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 105.476L-54.3332 105.476"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 148.157L-54.3332 148.157"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 190.839L-54.3332 190.839"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 233.521L-54.3332 233.52"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 276.202L-54.3332 276.202"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
            <path
              d="M868.333 318.884L-54.3332 318.884"
              stroke="#87FF85"
              style={{ stroke: "#87FF85", strokeOpacity: 1 }}
              strokeWidth="4"
            />
          </g>
        </g>
        <rect
          opacity="0.9"
          x="53.7632"
          y="69.9111"
          width="708.319"
          height="221.309"
          fill="#87FF85"
          stroke="black"
          style={{
            fill: "#87FF85",
            fillOpacity: 1,
            stroke: "black",
            strokeOpacity: 1,
          }}
        />
        <g opacity="0.9">
          <rect
            x="37.9185"
            y="54.3936"
            width="708.319"
            height="221.309"
            fill="white"
            style={{ fill: "white", fillOpacity: 1 }}
          />
          <rect
            x="37.9185"
            y="54.3936"
            width="708.319"
            height="221.309"
            stroke="black"
            style={{ stroke: "black", strokeOpacity: 1 }}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_3024_5373"
          x="-58.333"
          y="-28.5693"
          width="930.666"
          height="396.135"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_3024_5373"
          />
        </filter>
        <clipPath id="clip0_3024_5373">
          <rect
            width="800"
            height="340"
            rx="54"
            fill="white"
            style={{ fill: "white", fillOpacity: 1 }}
          />
        </clipPath>
      </defs>
      <text
        x="400"
        y="160"
        style={{ fill: "#1F2022" }}
        fontSize="61"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line1 || ""}
      </text>
      <text
        x="400"
        y="226"
        style={{ fill: "#1F2022" }}
        fontSize="50"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line2 || ""}
      </text>
    </svg>
  );
}

export default Techy;
